import { createDocument, getDocuments, updateDocumentByPath } from '../services/documents';

const sendSupportMail = async (supportForm) => {
  const data = await createDocument(supportForm, 'settings/supportMail');

  return data;
};

const sendPushNotification = async (pushNotificationForm) => {
  const data = await createDocument(pushNotificationForm, 'push-notification');

  return data;
};

const previewPushNotificationAudience = async (regionFilter) => {
  const data = await createDocument(regionFilter, 'push-notification/preview');

  return data;
};

interface PushNotificationHistoryFilter {
  page?: number;
  size?: number;
  dateFrom?: string;
  dateTo?: string;
  status?: string;
  targetType?: string;
  source?: string;
  createdUserPk?: number;
  recipientUserPk?: number;
}

const getPushNotificationHistory = async (filter: PushNotificationHistoryFilter = {}) => {
  const params = new URLSearchParams();
  Object.entries(filter).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
  });
  const qs = params.toString();
  const data: any = await getDocuments(`push-notification/history${qs ? '?' + qs : ''}`);
  return data;
};

const getPushNotificationRecipients = async (pushPk: number, page = 1, size = 50) => {
  const data: any = await getDocuments(`push-notification/history/${pushPk}/recipients?page=${page}&size=${size}`);
  return data;
};

const retryPushNotification = async (pushPk: number, userPks: number[]) => {
  const data = await createDocument({ userPks }, `push-notification/${pushPk}/retry`);
  return data;
};

const getPushConfig = async () => {
  const data: any = await getDocuments('settings/push-config');
  return data;
};

const updatePushConfig = async (maxUsersPerPush: number) => {
  const data: any = await updateDocumentByPath({ maxUsersPerPush }, 'settings/push-config');
  return data;
};

export {
  sendSupportMail,
  sendPushNotification,
  previewPushNotificationAudience,
  getPushNotificationHistory,
  getPushNotificationRecipients,
  retryPushNotification,
  getPushConfig,
  updatePushConfig,
};
